import { Link } from "react-router-dom";

export const accordionData = [
  {
    title: 'What is Kapitify?',
    content: `Kapitify is an online barter and recommerce platform based in Nigeria.`
  },
  {
    title: 'Why should I use Kapitify?',
    content:
      <div className="faq-item">
        <p>We are all about making our users comfortable. We have built Kapitify to:</p>
        <ul>
          <li> Be User friendly</li>

          <li> Have end-to-end encryption on chats</li>

          <li> Be SSL secured</li>

          <li> Offer real-time notifications</li>

          <li> Have fast loading time</li>

          <li> Offer 24/7 customer support</li>

          <li> Possess an appealing user interface</li>
        </ul>
        <p>We can guarantee an optimal experience.</p>
      </div>
  },
  {
    title: 'How does the swap process work?',
    content: ``
  },
  {
    title: 'What kind of items can I upload and swap?',
    content: `You can literally upload any item you want, except from the ones we explicitly prohibit.`
  },
    {
    title: 'Prohibited items on Kapitify',
    content: <div className="faq-item">
      <p>Users shall comply with all applicable laws, the <a href = "terms-of-use">Terms of Use</a>, and all posted platform rules and policies.</p>

      <p>Here is a non-exhaustive list of items of which is prohibited on Kapitify in Nigeria:</p>
      <ul>
        <li>  Narcotics, steroids, and any drugs or medications that require a prescription from a licensed medical specialist</li>

        <li>  Weapons</li>

        <li>  Restricted military/police items</li>

        <li>  Human organs</li>

        <li>  Illegal/pirated copies</li>

        <li>  Stolen property</li>

        <li>  Code grabbing and lock picking devices</li>

        <li>  Electronic equipment prohibited by the law</li>

        <li>  Items prohibited by the law, in particular:</li>
      </ul>

  
        <p> 1. Food, processed food, water, soft drinks, spirit drinks, medical devices, drugs, drug products, cosmetics, chemicals, agrochemicals, pesticides, veterinary drugs, or other goods if they have not been registered with the National Agency for Food & Drug Administration and Control (the “NAFDAC”) or other relevant authority of Nigeria;</p>

        <p>2.  Any goods, sale, distribution, or advertising of which is banned or restricted by the NAFDAC or any other relevant authority of Nigeria;</p>

        <p>3.  Any goods, sale, distribution or advertising of which is prohibited by applicable legislation of Nigeria;</p>

        <p>4.  Any goods that do not comply with standards and quality requirements imposed on such goods by applicable legislation of Nigeria;</p>

        <p>5. Any goods that are represented on the label or described as a treatment, preventative, or cure for diseases, disorders, or abnormal physical states specified by applicable legislation of Nigeria.</p>

        <p>6. Trophies and wildlife specimens (including but not limited to ivory artifacts and pangolin parts) in relation to which trade is prohibited by applicable legislation.</p>
      

      <p>If you have noticed any swaps promoting prohibited Items on Kapitify, please report them via the Customer Support.</p>
    </div>
  },
 
  // {
  //   title: 'What kind of items can I upload and swap?',
  //   content: `You can literally upload any item you want, except from the ones we explicitly prohibit.`
  // },
  // {
  //   title: 'Prohibited items on Kapitify',
  //   content: <div className="faq-item">
  //     <p>Users shall comply with all applicable laws, the <a href = "terms-of-use">Terms of Use</a>, and all posted platform rules and policies.</p>

  //     <p>Here is a non-exhaustive list of items of which is prohibited on Kapitify in Nigeria:</p>
  //     <ul>
  //       <li>  Narcotics, steroids, and any drugs or medications that require a prescription from a licensed medical specialist</li>

  //       <li>  Weapons</li>

  //       <li>  Restricted military/police items</li>

  //       <li>  Human organs</li>

  //       <li>  Illegal/pirated copies</li>

  //       <li>  Stolen property</li>

  //       <li>  Code grabbing and lock picking devices</li>

  //       <li>  Electronic equipment prohibited by the law</li>

  //       <li>  Items prohibited by the law, in particular:</li>
  //     </ul>

  //     <ol>
  //       <li>Food, processed food, water, soft drinks, spirit drinks, medical devices, drugs, drug products, cosmetics, chemicals, agrochemicals, pesticides, veterinary drugs, or other goods if they have not been registered with the National Agency for Food & Drug Administration and Control (the “NAFDAC”) or other relevant authority of Nigeria;</li>

  //       <li>  Any goods, sale, distribution, or advertising of which is banned or restricted by the NAFDAC or any other relevant authority of Nigeria;</li>

  //       <li>  Any goods, sale, distribution or advertising of which is prohibited by applicable legislation of Nigeria;</li>

  //       <li>  Any goods that do not comply with standards and quality requirements imposed on such goods by applicable legislation of Nigeria;</li>

  //       <li> Any goods that are represented on the label or described as a treatment, preventative, or cure for diseases, disorders, or abnormal physical states specified by applicable legislation of Nigeria.</li>

  //       <li> Trophies and wildlife specimens (including but not limited to ivory artifacts and pangolin parts) in relation to which trade is prohibited by applicable legislation.</li>
  //     </ol>

  //     <p>If you have noticed any swaps promoting prohibited Items on Kapitify, please report them via the Customer Support.</p>
  //   </div>
  // },
  {
    title: 'How do I upload an item on Kapitify?',
    content: <div className='faq-item spaced'>
        <ul>
          <li className='bold'>
            Register
          </li>
          <p>Register using your e-mail (or do it via Facebook, Google or Twitter).</p>

          <li className='bold'>
          Make photos of your item
          </li>
          <p>Feel free to make a lot of photos using your smartphone. Learn how to <Link to='#'>add photos</Link>.</p>
          <li className='bold'>Press Add Item in the menu or (+) in your profile page </li>
          </ul>
          <p>
            Then proceed to perform the following tasks:
          </p>
          <ol>
            <li>Upload your photos.</li>
            <li>Type in your item name.</li>
            <li>Choose a proper category and attribute.</li>
            <li>Answer <strong>the quality test</strong>. This helps us determine the quality of the item and give it an appropriate rating.</li>
            <li>Write a clear description of your item.</li>
            <li>Type in the item you wish to swap it for.</li>
            <p><strong>Note: If you wish to swap the item for anything, just tap on the I'm Open to Offers slider.</strong></p>
            <li>Select your state and type in your city.</li>
          </ol>
            <p>Congratulations! You just uploaded your first item on Kapitify.</p>
            <p> Don't forget to add your phone number via <Link to='/settings'>General Settings</Link>.</p>
            <p>Make sure you’re entering a correct phone number, so that Swappers can reach you!</p>
        
    </div>
  },
  {
    title: 'What happens after I upload an item?',
    content: <div className="faq-item">
      <p>
        After uploading your item, you'll see your item immediately in the platform. All you have to do is just sit back and relax, Kapitify's algorithm will help you find a Swapper.
      </p>
      <p>Note: Once you upload an item you cannot edit it again if needed.</p>
      <ul>
        <li>  You can delete your swaps any time you want. You just have to click on the three dots placed under the item, then select "delete".</li>
        <li> You shouldn’t publish swaps of the same content. They will be considered duplicates and won’t go active.</li>
        <li>  You can always share your swaps on your favorite social media platforms. You just have to click on the three dots placed under the item, then select "share".</li>
      </ul>
    </div>
  },
  {
    title: 'Can I sell on Kapitify?',
    content: <div className="faq-item"><p>Currently, Kapitify does not support a secure means of selling items.</p>
      <p> For now you have the sole discretion to discuss the transaction terms with swappers, but at your own risk.</p></div>
  },
 
  {
    title: 'Can I share my swaps on Facebook, Instagram, Twitter and WhatsApp?',
    content: <div className="faq-item">
      <p>Sure! It helps a lot to find more swappers. If you want to share the swap on social media, follow these steps:</p>
      <ul>
        <li> Log in to your Kapitify account</li>

        <li> Go to your profile</li>

        <li> Look for the swap you want to share</li>

        <li> You just have to click on the three dots placed under the item, then select "share".</li>
      </ul>
      <p>That's it! Now all your friends on social media know about the item you want to swap!</p>
    </div>
  },
  {
    title: <p>How long will my items stay on Kapitify?</p>,
    content: <div className="faq-item">
      <p> Your items remain on the platform for 1-3 months before they are automatically deleted or until you decide to delete them.</p>
      <p>Please note that you can delete and reupload your item if you haven't swapped your item.</p>
    </div>
  },
  {
    title: 'How do I contact Customer Support? ',
    content: <div className="faq-item">
      <p> Kapitify currently offers the following channels to contact support:</p>
      <ul>
        <li> Chat</li>
        <li>  Email</li>
      </ul>
      <p className="bold"> Chat</p>
      <p>Chat is the fastest way to get a response from Kapitify and we can resolve most questions with a quick conversation.</p>
      <p>To start a chat with one of our support agents from Kapitify platform:</p>
      <ul>
        <li>Click on <Link to='/customer-support'>Customer Support</Link></li>
      </ul>
      <p> Note: To better assist you with any troubleshooting, it's important for us to know as many details of the issue as possible.</p>
      <p className="bold"> Email</p>
      <p> For questions that are not urgent, we recommend submitting an email via <a href="https://kapitify@gmail.com">kapitify@gmail.com</a></p>

      <p>Attaching relevant screenshots to any support requests allows Kapitify support to solve your problem faster. Always be prepared to include or have screenshots ready that show your issue clearly.</p>

      <p>Do you provide phone support?</p>

      <p> Yes! you can reach us via call or WhatsApp. This is our support line  <a href="tel:+2349012391057" className="no-underline" >+2349012391057</a> </p>
    </div>
  },
  {
    title: 'How do I report a Swapper?',
    content: <div className="faq-item">
      <p>Send us an email immediately at <a href="https://kapitify@gmail.com" >kapitify@gmail.com</a> with the following information:</p>
      <ul>
        <li> The Swapper's name</li>
        <li> The screenshot of the recent conversation</li>
        <li> The issue you experienced</li>
      </ul>
      <p>We are truly sorry for your recent experience.</p>
      <p>We take issues like this very seriously.</p>
      <p>We will perform a thorough investigation, expect a reply from us within 48 hours.</p>
    </div>
  },
  {
    title: 'What is My Interests section and how does it work? ',
    content: <div className="faq-item">
      <p>This is the section that allows you to keep track of your favourite items and notifications that are of interest to you.</p>
      <p>Kapitify allows you to quickly mark an item that you want to keep an eye on or come back to later.</p>
      <ul>
        <li>Saving items to My Interest section </li>
        <p>You can click on the save item icon (heart icon). When the heart icon turns red, the item is saved into your interests.</p>
        <li>Removing an items from My Interest section</li>
      </ul>
      <p>This action can be performed in two ways:</p>
      <ol>
        <li>You can tap on my interest icon and remove them individually.</li>
        <li>You can search for the item on the homepage and tap on the red heart icon to remove them from my interest section.</li>
      </ol>
      <ul>
        <li>Having trouble?</li>
      </ul>
      <p>If items won’t save to your interests or are disappearing (and you are not at the 99 items limit), try clearing your browser’s cookies and cache.</p>
    </div>
  },
  {
    title: 'How do I search for items effectively?',
    content:<div className="faq-item">
      <p>Kapitify offers four searching tools that will help you narrow your options to the item you are looking for. Get to know how they each work to make the most out of your searches.</p>
      <ul>
        <li className="bold">Find item</li>
        <p>The " Find item" field is a keyword search. It matches the titles of swaps on Kapitify. Choose your keywords carefully. If all of the words you type in are not in the title, the item won’t appear in your search results.</p>
        <li className="bold">Location</li>
        <p>This is a functionality that helps limit your search results to a specific region. You will see a drop-down list of states options. You are to type in your city. If you don’t see your area appear, try an area nearby.</p>
        <li className="bold">Sort</li>
        <p>This is a functionality designed to allow you to make specific item searches based on the categories of the items.</p>
        <li className="bold">Filters</li>
      </ul>
      <p>Filters allow you to limit your searches to swaps with a specific attribute. This functionality can be accessed by tapping on the Sort section. The basic filters are:</p>
      <ol>
        <li>The item you wish to swap for</li>
        <li>Item swaps and open to offers swaps</li>
        <li>The category of the items </li>
      </ol>
      <p>After you’ve started a basic search, remember to check what filter options are available.</p>
      <p>How to get better search results?</p>
      <ul>
        <li className="bold">Change Up Your Keywords</li>
        <p>Everyone phrases things differently. If you’re not finding what you’re looking for, try changing out the words.</p>
        <li className="bold">Use a Filter in Place of a Keyword</li>
        <p>Most swappers on Kapitify are not professional advertisers. They often don’t put the most relevant keywords in their titles. They may include spelling mistakes. Using filters will show swaps that match what you want.</p>
      </ul>
    </div>
  },
  {
    title: 'How do I add Photos?',
    content: <div className="faq-item">
      <p>Adding Photos</p>
      <p>Photos are the first part of an ad that most swappers see. Adding clear, detailed pictures draws swappers into your ad and saves you time answering questions that could be answered with a photo. Kapitify allows up to 6 images on each ad. Don’t be afraid to use them all.</p>
      <p>Tips when taking photos:</p>
      <ul>
        <li>
        Use bright lighting and uncluttered background.
        </li>
        <li>
        Take photos of your item from different angles so buyers can get a 360 degree look.
        </li>
        <li>The larger the item you’re selling, the more photos you should take.</li>
      </ul>
      <p>To add photos:</p>
      <ul>
        <li>
        If you’re posting a new ad, tap "Post an Ad" or the addition symbol in your profile page.
        </li>
        <li>
        Click "Add Image" to choose photos from your file browser, to add more than one photo hold and tap multiple photos at the same time.
        </li>
      </ul>
        <p>Always remember, you cannot edit an ad once uploaded </p>
       <p>Please note that Kaptify will automatically delete all images from ads that have been inactive for 6 months or more.</p>
    </div>
  }

];
export const generalInfo = [
  {
    title: 'What Is a Bartering Platform? ',
    content: <div className="faq-item">
      <p> It is a digital platform that allows physical assets to be recorded and exchanged with ease, enabling users to exchange items without the use of any currency.</p>
      <p>Digital bartering platforms allow physical assets to be recorded and exchanged with ease, bringing barter-based transactions into today's context. Like an e-commerce platform, users upload the items they have to offer. People can then offer their items in exchange, organized by proximity if necessary. Like ridesharing or home rental apps, security features are offered to keep track of transactions, swappers' identities, protecting its users from possible scams and fraud-like circumstances.</p>
      <p>This platform can reduce bureaucracy, add liquidity to the global marketplace, and fundamentally reduce the need for intermediaries across worldwide trading systems. However, to work at scale, a standard measure of value must be established among all parties.</p>
    </div>
  },
  {
    title: 'Do you have any stores? ',
    content: `No, we are not a shop. Kapitify is a marketplace — here you can swap your stuff with real people. Any deal you make, you make with people and we exist just to help you find each other.`
  },
  {
    title: 'Do you offer any kind of delivery service? ',
    content: <div className="faq-item">
      <p> Currently, Kapitify does not support a secure means of delivering items, although we plan to partner up with top logistics companies soon. Stay tuned.</p>
      <p>For now we recommend that you meet swappers in person, within your location and in a public place.</p>
      <p>You can always discuss with the swapper a comfortable way of delivering, but at your own risk.</p>
    </div>
  }

]